import {
  Module, VuexModule, Mutation,
} from 'vuex-module-decorators';

@Module({ namespaced: true, name: 'loading' })
export default class LoadingModule extends VuexModule {
  loading = false;

  @Mutation
  updateLoadingStatus(status?: boolean) {
    if (status !== undefined) {
      this.loading = status;
    } else {
      this.loading = !this.loading;
    }
  }

  @Mutation
  start() {
    this.loading = true;
  }

  @Mutation
  stop() {
    this.loading = false;
  }

  get isLoading() {
    return this.loading;
  }
}
